/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  DenyExpenseRequest,
  ExpectedExpenseDto,
  ExpectedExpensesResponse,
  ExpenseApproveExpenseParams,
  ExpenseExtendedModel,
  ExpenseGetExpectedExpensesParams,
  ExpenseGetExpenseParams,
  ExpenseGetFileParams,
  ExpenseGetSignedUriParams,
  ExpenseModelBody,
  ExpenseTranslateExpenseParams,
  ExpenseUpdateExpectedExpensesParams,
  ExpenseUploadFileBody,
  TranslateCommentResponse,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useExpenseGetExpenseHook = () => {
  const expenseGetExpense = useCustomInstance<ExpenseExtendedModel>();

  return useCallback(
    (params?: ExpenseGetExpenseParams, signal?: AbortSignal) => {
      return expenseGetExpense({
        url: `/api/Expense/GetExpense`,
        method: 'GET',
        params,
        signal,
      });
    },
    [expenseGetExpense]
  );
};

export const getExpenseGetExpenseQueryKey = (
  params?: ExpenseGetExpenseParams
) => {
  return [`/api/Expense/GetExpense`, ...(params ? [params] : [])] as const;
};

export const useExpenseGetExpenseQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetExpenseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExpenseGetExpenseQueryKey(params);

  const expenseGetExpense = useExpenseGetExpenseHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>
  > = ({ signal }) => expenseGetExpense(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExpenseGetExpenseQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>
>;
export type ExpenseGetExpenseQueryError = unknown;

export const useExpenseGetExpense = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetExpenseParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetExpenseHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExpenseGetExpenseQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExpenseSaveExpenseHook = () => {
  const expenseSaveExpense = useCustomInstance<number>();

  return useCallback(
    (expenseModelBody: ExpenseModelBody) => {
      return expenseSaveExpense({
        url: `/api/Expense/SaveExpense`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expenseModelBody,
      });
    },
    [expenseSaveExpense]
  );
};

export const useExpenseSaveExpenseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>,
    TError,
    { data: ExpenseModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>,
  TError,
  { data: ExpenseModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseSaveExpense = useExpenseSaveExpenseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>,
    { data: ExpenseModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return expenseSaveExpense(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseSaveExpenseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>
>;
export type ExpenseSaveExpenseMutationBody = ExpenseModelBody;
export type ExpenseSaveExpenseMutationError = unknown;

export const useExpenseSaveExpense = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>,
    TError,
    { data: ExpenseModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseSaveExpenseHook>>>,
  TError,
  { data: ExpenseModelBody },
  TContext
> => {
  const mutationOptions = useExpenseSaveExpenseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseDeleteExpenseHook = () => {
  const expenseDeleteExpense = useCustomInstance<string>();

  return useCallback(
    (expenseModelBody: ExpenseModelBody) => {
      return expenseDeleteExpense({
        url: `/api/Expense/DeleteExpense`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: expenseModelBody,
      });
    },
    [expenseDeleteExpense]
  );
};

export const useExpenseDeleteExpenseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>,
    TError,
    { data: ExpenseModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>,
  TError,
  { data: ExpenseModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseDeleteExpense = useExpenseDeleteExpenseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>,
    { data: ExpenseModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return expenseDeleteExpense(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseDeleteExpenseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>
>;
export type ExpenseDeleteExpenseMutationBody = ExpenseModelBody;
export type ExpenseDeleteExpenseMutationError = unknown;

export const useExpenseDeleteExpense = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>,
    TError,
    { data: ExpenseModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseDeleteExpenseHook>>>,
  TError,
  { data: ExpenseModelBody },
  TContext
> => {
  const mutationOptions = useExpenseDeleteExpenseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseUploadFileHook = () => {
  const expenseUploadFile = useCustomInstance<string>();

  return useCallback(
    (expenseUploadFileBody: ExpenseUploadFileBody) => {
      const formData = new FormData();
      if (expenseUploadFileBody.imageFile !== undefined) {
        formData.append('imageFile', expenseUploadFileBody.imageFile);
      }
      if (expenseUploadFileBody.fileEnding !== undefined) {
        formData.append('fileEnding', expenseUploadFileBody.fileEnding);
      }

      return expenseUploadFile({
        url: `/api/Expense/UploadFile`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      });
    },
    [expenseUploadFile]
  );
};

export const useExpenseUploadFileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>,
    TError,
    { data: ExpenseUploadFileBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>,
  TError,
  { data: ExpenseUploadFileBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseUploadFile = useExpenseUploadFileHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>,
    { data: ExpenseUploadFileBody }
  > = (props) => {
    const { data } = props ?? {};

    return expenseUploadFile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseUploadFileMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>
>;
export type ExpenseUploadFileMutationBody = ExpenseUploadFileBody;
export type ExpenseUploadFileMutationError = unknown;

export const useExpenseUploadFile = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>,
    TError,
    { data: ExpenseUploadFileBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseUploadFileHook>>>,
  TError,
  { data: ExpenseUploadFileBody },
  TContext
> => {
  const mutationOptions = useExpenseUploadFileMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseGetFileHook = () => {
  const expenseGetFile = useCustomInstance<Blob>();

  return useCallback(
    (params?: ExpenseGetFileParams, signal?: AbortSignal) => {
      return expenseGetFile({
        url: `/api/Expense/GetFile`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal,
      });
    },
    [expenseGetFile]
  );
};

export const getExpenseGetFileQueryKey = (params?: ExpenseGetFileParams) => {
  return [`/api/Expense/GetFile`, ...(params ? [params] : [])] as const;
};

export const useExpenseGetFileQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetFileParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExpenseGetFileQueryKey(params);

  const expenseGetFile = useExpenseGetFileHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>
  > = ({ signal }) => expenseGetFile(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExpenseGetFileQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>
>;
export type ExpenseGetFileQueryError = unknown;

export const useExpenseGetFile = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetFileParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetFileHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExpenseGetFileQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExpenseGetSignedUriHook = () => {
  const expenseGetSignedUri = useCustomInstance<string>();

  return useCallback(
    (params?: ExpenseGetSignedUriParams, signal?: AbortSignal) => {
      return expenseGetSignedUri({
        url: `/api/Expense/GetSignedUri`,
        method: 'GET',
        params,
        signal,
      });
    },
    [expenseGetSignedUri]
  );
};

export const getExpenseGetSignedUriQueryKey = (
  params?: ExpenseGetSignedUriParams
) => {
  return [`/api/Expense/GetSignedUri`, ...(params ? [params] : [])] as const;
};

export const useExpenseGetSignedUriQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetSignedUriParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExpenseGetSignedUriQueryKey(params);

  const expenseGetSignedUri = useExpenseGetSignedUriHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>
  > = ({ signal }) => expenseGetSignedUri(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExpenseGetSignedUriQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>
>;
export type ExpenseGetSignedUriQueryError = unknown;

export const useExpenseGetSignedUri = <
  TData = Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>,
  TError = unknown,
>(
  params?: ExpenseGetSignedUriParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetSignedUriHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExpenseGetSignedUriQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExpenseDenyExpenseHook = () => {
  const expenseDenyExpense = useCustomInstance<void>();

  return useCallback(
    (denyExpenseRequest: DenyExpenseRequest) => {
      return expenseDenyExpense({
        url: `/api/Expense/DenyExpense`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: denyExpenseRequest,
      });
    },
    [expenseDenyExpense]
  );
};

export const useExpenseDenyExpenseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>,
    TError,
    { data: DenyExpenseRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>,
  TError,
  { data: DenyExpenseRequest },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseDenyExpense = useExpenseDenyExpenseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>,
    { data: DenyExpenseRequest }
  > = (props) => {
    const { data } = props ?? {};

    return expenseDenyExpense(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseDenyExpenseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>
>;
export type ExpenseDenyExpenseMutationBody = DenyExpenseRequest;
export type ExpenseDenyExpenseMutationError = unknown;

export const useExpenseDenyExpense = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>,
    TError,
    { data: DenyExpenseRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseDenyExpenseHook>>>,
  TError,
  { data: DenyExpenseRequest },
  TContext
> => {
  const mutationOptions = useExpenseDenyExpenseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseApproveExpenseHook = () => {
  const expenseApproveExpense = useCustomInstance<void>();

  return useCallback(
    (params?: ExpenseApproveExpenseParams) => {
      return expenseApproveExpense({
        url: `/api/Expense/ApproveExpense`,
        method: 'POST',
        params,
      });
    },
    [expenseApproveExpense]
  );
};

export const useExpenseApproveExpenseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>,
    TError,
    { params?: ExpenseApproveExpenseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>,
  TError,
  { params?: ExpenseApproveExpenseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseApproveExpense = useExpenseApproveExpenseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>,
    { params?: ExpenseApproveExpenseParams }
  > = (props) => {
    const { params } = props ?? {};

    return expenseApproveExpense(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseApproveExpenseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>
>;

export type ExpenseApproveExpenseMutationError = unknown;

export const useExpenseApproveExpense = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>,
    TError,
    { params?: ExpenseApproveExpenseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseApproveExpenseHook>>>,
  TError,
  { params?: ExpenseApproveExpenseParams },
  TContext
> => {
  const mutationOptions = useExpenseApproveExpenseMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseGetExpectedExpensesHook = () => {
  const expenseGetExpectedExpenses =
    useCustomInstance<ExpectedExpensesResponse>();

  return useCallback(
    (params?: ExpenseGetExpectedExpensesParams, signal?: AbortSignal) => {
      return expenseGetExpectedExpenses({
        url: `/api/Expense/GetExpectedExpenses`,
        method: 'GET',
        params,
        signal,
      });
    },
    [expenseGetExpectedExpenses]
  );
};

export const getExpenseGetExpectedExpensesQueryKey = (
  params?: ExpenseGetExpectedExpensesParams
) => {
  return [
    `/api/Expense/GetExpectedExpenses`,
    ...(params ? [params] : []),
  ] as const;
};

export const useExpenseGetExpectedExpensesQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>
  >,
  TError = unknown,
>(
  params?: ExpenseGetExpectedExpensesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExpenseGetExpectedExpensesQueryKey(params);

  const expenseGetExpectedExpenses = useExpenseGetExpectedExpensesHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>>
  > = ({ signal }) => expenseGetExpectedExpenses(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ExpenseGetExpectedExpensesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>>
>;
export type ExpenseGetExpectedExpensesQueryError = unknown;

export const useExpenseGetExpectedExpenses = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>
  >,
  TError = unknown,
>(
  params?: ExpenseGetExpectedExpensesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<ReturnType<typeof useExpenseGetExpectedExpensesHook>>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useExpenseGetExpectedExpensesQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useExpenseUpdateExpectedExpensesHook = () => {
  const expenseUpdateExpectedExpenses = useCustomInstance<void>();

  return useCallback(
    (
      expectedExpenseDto: ExpectedExpenseDto[],
      params?: ExpenseUpdateExpectedExpensesParams
    ) => {
      return expenseUpdateExpectedExpenses({
        url: `/api/Expense/UpdateExpectedExpenses`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: expectedExpenseDto,
        params,
      });
    },
    [expenseUpdateExpectedExpenses]
  );
};

export const useExpenseUpdateExpectedExpensesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>
    >,
    TError,
    {
      data: ExpectedExpenseDto[];
      params?: ExpenseUpdateExpectedExpensesParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>>,
  TError,
  { data: ExpectedExpenseDto[]; params?: ExpenseUpdateExpectedExpensesParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseUpdateExpectedExpenses = useExpenseUpdateExpectedExpensesHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>
    >,
    { data: ExpectedExpenseDto[]; params?: ExpenseUpdateExpectedExpensesParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return expenseUpdateExpectedExpenses(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseUpdateExpectedExpensesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>>
>;
export type ExpenseUpdateExpectedExpensesMutationBody = ExpectedExpenseDto[];
export type ExpenseUpdateExpectedExpensesMutationError = unknown;

export const useExpenseUpdateExpectedExpenses = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>
    >,
    TError,
    {
      data: ExpectedExpenseDto[];
      params?: ExpenseUpdateExpectedExpensesParams;
    },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseUpdateExpectedExpensesHook>>>,
  TError,
  { data: ExpectedExpenseDto[]; params?: ExpenseUpdateExpectedExpensesParams },
  TContext
> => {
  const mutationOptions =
    useExpenseUpdateExpectedExpensesMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useExpenseTranslateExpenseHook = () => {
  const expenseTranslateExpense = useCustomInstance<TranslateCommentResponse>();

  return useCallback(
    (params?: ExpenseTranslateExpenseParams) => {
      return expenseTranslateExpense({
        url: `/api/Expense/TranslateExpense`,
        method: 'POST',
        params,
      });
    },
    [expenseTranslateExpense]
  );
};

export const useExpenseTranslateExpenseMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>,
    TError,
    { params?: ExpenseTranslateExpenseParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>,
  TError,
  { params?: ExpenseTranslateExpenseParams },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const expenseTranslateExpense = useExpenseTranslateExpenseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>,
    { params?: ExpenseTranslateExpenseParams }
  > = (props) => {
    const { params } = props ?? {};

    return expenseTranslateExpense(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExpenseTranslateExpenseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>
>;

export type ExpenseTranslateExpenseMutationError = unknown;

export const useExpenseTranslateExpense = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>,
    TError,
    { params?: ExpenseTranslateExpenseParams },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useExpenseTranslateExpenseHook>>>,
  TError,
  { params?: ExpenseTranslateExpenseParams },
  TContext
> => {
  const mutationOptions = useExpenseTranslateExpenseMutationOptions(options);

  return useMutation(mutationOptions);
};
